export const ABSENCE_TYPE_POLICY_PATH = "/settings-menu/absence-type-policy";
